export default __webpack_public_path__ + "static/media/notification-7.4e2e72ea.mp3";